import React, { createContext, useContext, useRef, useState, useCallback } from "react";

const OverlayContext = createContext({
  show: () => {},
  hide: () => {},
  visible: false,
});

export function OverlayProvider({ children }) {
  const [visible, setVisible] = useState(false);
  const minHideAtRef = useRef(0);      // не скрывать раньше этого времени
  const failsafeRef = useRef(null);    // id таймера-предохранителя

  // показать оверлей
  const show = useCallback((minMs = 50, failsafeMs = 1000) => {
    setVisible(true);
    minHideAtRef.current = Date.now() + minMs;

    if (failsafeRef.current) clearTimeout(failsafeRef.current);
    failsafeRef.current = setTimeout(() => {
      setVisible(false);
      failsafeRef.current = null;
    }, failsafeMs);
  }, []);

  // спрятать оверлей (с учётом минимального времени показа)
  const hide = useCallback(() => {
    const left = minHideAtRef.current - Date.now();
    const doHide = () => {
      setVisible(false);
      if (failsafeRef.current) {
        clearTimeout(failsafeRef.current);
        failsafeRef.current = null;
      }
    };
    if (left > 0) setTimeout(doHide, left);
    else doHide();
  }, []);

  return (
    <OverlayContext.Provider value={{ show, hide, visible }}>
      {children}
    </OverlayContext.Provider>
  );
}

export const useOverlay = () => useContext(OverlayContext);
